/* eslint-disable no-console */
/* eslint-disable max-len */
import { Box, Grid, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import React, { memo, useContext, useId, useMemo, useState } from 'react';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { TbClockHour3 } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import NewDialogPopup from '../../../../../../components/Common/NewDialogPopup/NewDialogPopup';
import ProfilePic from '../../../../../../components/Common/ProfilePic';
import { LanguageContext } from '../../../../../../libs/Context';
import { catchErr, DateDiff, dateFormatDDMMMYYYYHHMM } from '../../../../../../libs/HelperContent';
import { deleteFeedsAPI, upatedFeedsAPI } from '../../../../../actions/feeds_actions_new';
import { feedActionContext } from '../../../../index';
import CreationFieldPopUp from '../../FeedCreation/CreationPopup';
import MentionMenu from './TagMenu';
import ReportFeeds from './ReportFeeds';
import BookMarkButton from '../../../Reusable/BookMarkButton';
import useNavigateProfile from '../../../CustomHooks/useNavigateProfile';
import useFeedApproval from '../../FeedCreation/CustomHooks/useFeedApproval';

const FeedHeader = (props:any) =>
{
	const { feed, delCloseGetApi, handleUpdateFeed, index, from, contextT, requestT } = props;
	const userData = useSelector((state: any) => state?.mysession?.session);
	const { language } = useContext(LanguageContext);
	const [ isLoading, setLoading ] = useState(false);
	const [ menuData, setMenuData ] = useState<any>([]);
	const [ anchorEl, setAnchorEl ] = useState(null);
	const [ menuState, setMenuState ] = useState({
		edit   : false,
		delete : false,
		report : false
	});
	const randomId = useId();

	const { type } = useParams();
	const open = Boolean(anchorEl);
	const isBookmarks = type === 'bookmarks';
	const isCreatedByuser = userData?.userId === feed?.createdBy;
	const isCompanyFeed = userData?.companyId === feed?.createdBy;
	const { isFeedsAdmin } = useFeedApproval();
	const isEditable = !isBookmarks && (isCreatedByuser || (isCompanyFeed && isFeedsAdmin));
	const isDraft = feed?.isActive === false;
	const isApproved = feed?.status === 'active' || type !== 'pendingapproval';
	const navigate = useNavigate();
	const location = useLocation();
	const isReportable = !isCreatedByuser && !isDraft && isApproved && !(isFeedsAdmin && isCompanyFeed);
	const urlParams = new URLSearchParams(location.search);

	const postTime = type === 'draft' ? feed?.createdAt : feed?.postedAt;
	const { handleFeedAction, setFeedCardActn, feedCardActn } = useContext(feedActionContext);
	const amITagged = useMemo(() => feed?.taggedPeople?.some((each) => each?.userId === userData?.userId), [ feed?.taggedPeople ]);
	const isFeedPendingOrRejected = [ 'pending', 'rejected' ].includes(feed?.status);
	// const imageId = useId();

	// Handlers for managing menu options
	const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
	const handleMenuClose = () => setAnchorEl(null);

	const handleOpenMenu = (key, feedData) =>
	{
		setMenuState((prevState) => ({
			...prevState,
			[key] : true
		}));
		setMenuData(feedData);
		handleMenuClose();
	};

	const closeOpenedComments = () =>
	{
		if (feedCardActn?.[1]?._id === feed?._id) setFeedCardActn([]);
	};

	// Delete_feeds handlers
	const deleteFeedsHandler = async () =>
	{
		setLoading(true);
		try
		{
			const queryParams:any = {
				id      : menuData?._id,
				comid   : userData?.companyId,
				empRole : userData?.empRole
			};

			if (feed?.scheduledAt)
			{
				queryParams.schedule = Boolean(feed.scheduledAt);
			}

			const res = await deleteFeedsAPI(queryParams);

			if (res?.status)
			{
				// refreshFeedData();
				delCloseGetApi && delCloseGetApi(true);
				handleFeedAction('append', 'remove_feed', { ...feed, index });
				toast.success(language.feedDelSuccess);
				setMenuState((prevState) => ({ ...prevState, delete: false }));
				closeOpenedComments();

				if (location.pathname === '/news' && urlParams.has('post'))
				{
					navigate('/news');
				}
			}
			else
			{
				console.log('delete status', res?.status);
			}
		}
		catch (error)
		{
			console.log(error);
			catchErr(error);
		}
		finally
		{
			setLoading(false);
		}
	};

	// Close_menu
	const handleCloseMenu = async (key) =>
	{
		setMenuState((prevState) => ({
			...prevState,
			[key] : false
		}));
		setMenuData([]);
	};

	const handleEditCallBack = (updatedObj) =>
	{
		handleUpdateFeed(updatedObj);
	};

	const handleMoveDraft = async () =>
	{
		const body = feed;

		body.isActive = false;
		body.feedId = feed?._id;
		body.self = Boolean(isCreatedByuser);

		setLoading(true);

		const query = {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};

		try
		{
			const res = await upatedFeedsAPI(body, query);

			if (res?.status)
			{
				delCloseGetApi && delCloseGetApi(true);
				handleFeedAction('append', 'remove_feed', { ...feed, index });
				toast.success(language.feedMovedToDraft);
				setMenuState((prevState) => ({ ...prevState, delete: false }));
				closeOpenedComments();

				if (location.pathname === '/news' && urlParams.has('post'))
				{
					navigate('/news');
				}
			}
			else
			{
				console.log(res, '-----------');
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setLoading(false);
		}
	};

	// removed feed.active, as it causing flickering effect while clicking delete option in three dots icons and when popup opens, and clicking move to draft

	const showMovedToDraftBtn =
	{
		btn3Label    : language.moveToDraft,
		btn3Variant  : 'primary',
		btn3Callback : handleMoveDraft
	};

	const [ tagdAnchorEl, setTagdAnchorEl ] = useState<null | HTMLElement>(null);

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) =>
	{
		setTagdAnchorEl(event.currentTarget);
	};

	const handleClose = () =>
	{
		setTagdAnchorEl(null);
	};

	const getTagCreatedByStatus = () =>
	{
		if (!feed) return false;

		const hasTaggedPeople = feed?.taggedPeople?.length > 0;

		if (!hasTaggedPeople) return false;

		const isCompanyRole = feed?.userData?.role === 'company';

		return isCompanyRole
			? feed?.createdBy === userData?.companyId
			: feed?.createdBy === userData?.userId;
	};

	const { redirectToProfile, canNavigate } = useNavigateProfile(feed);

	return (
		<Grid container width={'100%'} pb={0.5}>
			{/* Profile Section */}
			<Grid xs minWidth={0} flexShrink={0}>
				<Stack direction={'row'} alignItems={'center'} spacing={1}>
					<Box display='inline-flex'
						height={40}
						width={40}
						onClick={redirectToProfile}
						className={canNavigate ? 'pointer brdrBlackSM brdrRadius50' : ''}
					>
						<ProfilePic

							imagePath={
								[ 'employee', 'individual' ].includes(feed?.userData?.role)
									? `${feed?.createdBy}.jpeg?t=${randomId}}`
									: `${feed?.createdBy}_logo.jpeg?t=${randomId}`
							}
							// imagePath={`${feed?.createdBy}_${[ 'employee', 'individual' ].includes(feed?.userData?.role) ? 'profile' : 'logo'}.jpeg?t=${randomId}`}
							defaultImg={([ 'employee', 'individual' ].includes(feed?.userData?.role) ? '/images/icons/defaultUser.svg' : '/images/logos/no_logo.png')}
							alt={language.createdBy}
							className='brdrRadius50'
							from={[ 'employee', 'individual' ].includes(feed?.userData?.role) ? 'selfProfile' : ''}
						/>
					</Box>

					{/* Content Section */}
					<Stack direction='column'>
						<Stack direction='row' alignItems='center' spacing={1}>
							<Typography
								variant='subtitle1'
								fontWeight='var(--font500)'
								sx={{
									whiteSpace   : 'nowrap',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									maxWidth     : '300px',
									lineHeight   : 1.5
								}}
								className={`${canNavigate ? 'pointer ' : ''} capitalTxt`}
								onClick={redirectToProfile}
							>
								{feed?.userData?.role === 'company'
									? feed?.userData?.companyName
									: feed?.userData?.fullName}
							</Typography>
							{feed?.repostObj?.feedId &&
							<Typography variant='body2' fontWeight='var(--font500)' color='#B2B2B2'>{`(${language.reposted})`}</Typography>
							}
							{amITagged &&
							// <Typography variant='body2' fontWeight='var(--font500)' color='#B2B2B2'>{language.taggedYou}</Typography>
							<Typography color='#B2B2B2' fontSize={12} fontWeight={500} sx={{ cursor: 'pointer' }}>
								{language.taggedYou}
								{feed?.taggedPeople?.length > 1 && (
									<Typography
										component='span'
										color='#24A4C4'
										fontSize={12}
										fontWeight={500}
										onClick={handleClick}
									>
										+{feed?.taggedPeople?.length - 1}
									</Typography>
								)}
							</Typography>
							}
							{!amITagged && getTagCreatedByStatus() && (
								<Typography color='#B2B2B2' fontSize={12} fontWeight={500} sx={{ cursor: 'pointer', textTransform: 'capitalize' }} pt={0.5}>
									{language.mentioned} {feed?.taggedPeople[0]?.name}
									{feed?.taggedPeople?.length > 1 && (
										<Typography
											component='span'
											color='#24A4C4'
											fontSize={12}
											fontWeight={500}
											onClick={handleClick}
										>
											+{feed?.taggedPeople?.length - 1}
										</Typography>
									)}
								</Typography>
							)}
						</Stack>
						{!feed?.scheduledAt && <Typography fontSize={'var(--pixel12)'} component={'span'} color={'rgba(178, 178, 178, 1)'}>
							{DateDiff(postTime, new Date().valueOf())}
					&nbsp;{feed?.isEdited && postTime ? `(${language?.edited})` : ''}
						</Typography>}
					</Stack>
				</Stack>

				{/* {isArchiveOpen && <span className='lightTxt headingXSM'>{feed?.isEdited && feed?.createdAt
						? `${DateDiff(feed?.createdAt, new Date().valueOf())} (${language?.edited}) `
						: feed?.createdAt && `${DateDiff(feed?.createdAt, new Date().valueOf())}`}</span>}
				*/}
			</Grid>

			{/* Scheduled Time and Menu Icon */}
			<Grid item display='flex' alignItems='start'>
				{/* {scheduled && ( */}
				{feed?.scheduledAt &&
				<Stack direction='row' alignItems='center' pr={3} spacing='var(--pixel4)'>
					<Box display='flex'>
						<TbClockHour3 fontSize='var(--pixel14)' color='var(--txtColorBlackL)' />
					</Box>
					<Typography fontSize='var(--pixel12)' fontWeight='var(--font500)' color='var(--txtColorBlackL)'>
						{dateFormatDDMMMYYYYHHMM(feed.scheduledAt)}
					</Typography>
				</Stack>}
				{/* attaching speaker animation here when audio playing in feed */}
				<span id={`description_speak_icon_${feed?._id}`}/>
				{/* bookmark icon handling, here you can handle either form or requestT */}
				{!feed?.scheduledAt && from !== 'repost' && type !== 'draft' && !isFeedPendingOrRejected && (
					<Tooltip title={language?.Bookmark} placement='top'>
						<Grid item display='flex' pr={1.5}>
							<BookMarkButton
								key={feed?.bookMark}
								feedId={feed?._id}
								isBookmarked={feed?.bookMark}
								disabled={[ 'poll', 'occasion' ].includes(feed?.feedType)}
							/>
						</Grid>
					</Tooltip>
				)}
				{from !== 'repost' && (isEditable || isReportable) &&
				<BsThreeDotsVertical
					style={{ cursor: 'pointer' }}
					fontSize='var(--pixel18)'
					color='rgba(83, 100, 113, 1)'
					onClick={handleMenuOpen}
				/>}
			</Grid>
			{/* Dropdown Menu */}
			{
				<Menu
					anchorEl={anchorEl}
					open={open}
					onClose={handleMenuClose}
					anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
					transformOrigin={{ vertical: 'top', horizontal: 'right' }}
					PaperProps={{
						sx : {
							width        : '145px',
							borderRadius : '13px'
						}
					}}
				>
					{/* Report For Everyone */}
					{isReportable &&
					<MenuItem onClick={() => handleOpenMenu('report', feed)}>{language?.reportFeed}</MenuItem>
						// <MenuItem onClick={handleReportClick}>{language.reportFeed}</MenuItem>
					}
					{/* feed can be edited by the creator and company feeds can be edited by other admins */}
					{isEditable && !feed?.pollsubmitted &&
					<MenuItem onClick={() => handleOpenMenu('edit', feed)}>{language?.edit}</MenuItem>}
					{/* Delete Will Be Role Based */}
					{isEditable &&
					<MenuItem onClick={() => handleOpenMenu('delete', feed)}>{language?.delete}</MenuItem>}
				</Menu>}

			{/* Edit existing feeds */}
			{menuState?.edit && menuData?._id !== '' &&
			<CreationFieldPopUp
				OpenPop={menuState?.edit && menuData !== null}
				handleClosePop={() => handleCloseMenu('edit')}
				editData={menuData}
				requestT={'editFeeds'}
				handleEditCallBack={handleEditCallBack}
			/>
			}

			{/* Delete Confirmation Popup */}
			{menuState?.delete && (
				<NewDialogPopup
					open={menuState?.delete}
					handleConfirm={deleteFeedsHandler}
					closeCallBack={() => handleCloseMenu('delete')}
					type={language.yes}
					label={language.deletePost}
					from='feedCreate'
					formatType={language.no}
					loading={isLoading}
					id={undefined}
					{...(requestT?.type === 'draft' && !feed?.isActive ? {} : feed?.scheduledAt ? {} : showMovedToDraftBtn)}
				/>

			)}
			<MentionMenu feed={feed} anchorEl={tagdAnchorEl} onClose={handleClose} />
			{ menuState?.report && (
				<ReportFeeds
					key={menuData?._id}
					onClose={() => handleCloseMenu('report')}
					open={Boolean(menuState?.report)}
					reportedFeedData={menuData}
					reportedFeedIndex={index}
					contextT={contextT}
				/>
			)}

		</Grid>
	);
};

export default memo(FeedHeader);